import axios from 'axios';

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  getCountryCode() {
    const baseUrl = "https://websiteapis.azurewebsites.net/BBCountry/Location";
    return apiClient.get(baseUrl);
  }
};
